import styled from "styled-components";
import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { Grid } from "@material-ui/core";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";

const orange = (props) => props.theme.palette.orange;
const red = (props) => props.theme.palette.red;
const green = (props) => props.theme.palette.green;
const lightgrey = (props) => props.theme.palette.lightgrey;
const gold = (props) => props.theme.palette.gold;

export const StyledChip = styled(Chip)`
  width: 100% !important;
`;

export const TableChip = styled(Chip)`
  height: auto !important;
  width: 84px;

  span {
    font-size: 0.675rem !important;
    padding: 5px 10px;
  }
`;

export const ProcessDiv = styled.div`
  color: ${orange} !important;
  display: inline-block !important;
  padding: 1px !important;
`;

export const FailedDiv = styled.div`
  color: ${red} !important;
  display: inline-block !important;
  padding: 1px !important;
`;

export const SuccessDiv = styled.div`
  color: ${green} !important;
  display: inline-block !important;
  padding: 1px !important;
`;

export const Pendingdiv = styled.div`
  color: ${lightgrey} !important;
  display: inline-block !important;
  padding: 1px !important;
`;

export const CanceledDiv = styled.div`
  color: ${gold} !important;
  display: inline-block !important;
  padding: 1px !important;
`;

export const StyledContainer = styled(Grid)`
  position: relative !important;
`;

export const BtnCloseModal = styled(Btn)``;

export const DemonstrativoIcon = styled(LocalAtmIcon)`
  height: 42px !important;
`;
